import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";

const SearchInputArenaMutual = styled.input`
      height: initial;
      margin: auto 0;
      color: ${props => props.theme.colors.bodyText};
      background: ${props => props.theme.colors.componentBackground};

      &:focus {
        background: ${props => props.theme.colors.componentBackground};
      }
`;

export const SearchInputArenaDefaultPCBox = styled(SearchInputArenaMutual)`
    position: relative;
    width: 32rem;
    padding: 1rem 2rem 1rem 5rem;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1;
    border-radius: 2rem;
    border: 2px solid transparent;
    transition: width 0.2s ease;

    &:focus {
        width: 45rem;
        transition: width 0.2s ease;
    }
    &::placeholder {
      color: ${props => props.theme.colors.componentTextInfo};
    }
`;
export const SearchInputArenaDefaultMobileBox = styled(SearchInputArenaMutual)`
      display: flex;
      width: 100%;
      padding: 1.5rem 5.5rem;
      font-family: ${props => props.theme.font.family.regular};
      font-size: 1.6rem;
      font-weight: 300;
      border: none;

    &::placeholder {
      color: ${props => props.theme.colors.bodyText};
    }

    &:focus {
        border: none;
        box-shadow: none;
    }
`;

export const SearchInputAreaDefaultBox = styledByDevice(SearchInputArenaDefaultPCBox,SearchInputArenaDefaultMobileBox);